exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.homepage-content[data-v-2dcd5dfc] {\r\n  height: 100%;\r\n  display: -ms-grid;\r\n  display: grid;\r\n  -ms-grid-rows: 1fr auto;\r\n      grid-template-rows: 1fr auto;\r\n  -ms-flex-align: start;\r\n      align-items: start;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2dcd5dfc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/home/index.page.vue
// module id = 589
// module chunks = 0